import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/(static)/(rewards)/rewards/page.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/utils/cookies/client.ts");
